import { useHistory, useParams } from "react-router-dom";

import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { useNotification } from "app/NotificationProvider";
import { Base64 } from "js-base64";
import {
  FileUpload,
  getSingleFileUploadViaFileEntryApi,
  useAppDispatch,
} from "model";
import { useEffect } from "react";

export default function FileDownload() {
  const { fileEntryId } = useParams<{ fileEntryId: string }>();
  const { goBackParam } = useParams<{ goBackParam: string }>();
  const goBack = goBackParam === "true";
  const dispatch = useAppDispatch();
  const { notify } = useNotification();

  const history = useHistory();
  const downloadFile = async () => {
    const fileUpload = (
      await dispatch(getSingleFileUploadViaFileEntryApi({ guid: fileEntryId }))
    ).payload as FileUpload;
    if (
      Capacitor.getPlatform() === "ios" ||
      Capacitor.getPlatform() === "android"
    ) {
      return (
        await Filesystem.writeFile({
          path: fileUpload.fileName,
          data: fileUpload.file,
          directory: Directory.Documents,
          recursive: true,
        })
      ).uri;
    } else {
      const data = Base64.toUint8Array(fileUpload.file);
      const blob = new Blob([data]);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("display", "none");
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileUpload.fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    }
    return fileUpload.fileName;
  };

  useEffect(() => {
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("display", "none");
    a.onclick = async () => {
      const fileName = await downloadFile();
      notify(`Saved file ${fileName}`);
      if (goBack) {
        history.goBack();
      } else if (goBackParam === "file-management-overview") {
        history.push("/file-management-overview");
      }
    };
    a.click();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}
